import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import getCashRegisterLogs from '../../gql/getCashRegisterLogs'
import { useLazyQuery } from 'components/graphql'
import Button from 'components/Button'
import { Modal } from 'components/Modal'
import moment from 'moment'
import Divider from 'components/Divider'
import { ReactComponent as Terminal } from 'media/icons/terminal.svg'
import { DateTimePicker } from 'components/forms'

const DownloadLogs = ({ deviceId, deviceName, isDisabled }) => {
	const [t] = useTranslation()
	const [openModal, setOpenModal] = useState(false)
	const [date, setDate] = useState(moment(new Date()).utc())
	const [showError, setShowError] = useState(false)
	const [getLog, { loading }] = useLazyQuery(getCashRegisterLogs, {
		onCompleted: res => {
			const url = res?.getCashRegisterLogs?.link
			url === null ? setShowError(true) : window.location.href = url
		},
		onError: error => error && setShowError(true)
	})
	const handleGetLog = (logsType) => {
		setShowError(false)
		getLog({
			variables: {
				cashRegisterId: deviceId,
				date: date,
				logsType
			}
		})
	}

	return(
		<>
			<Button
				type='button'
				onClick={() => setOpenModal(true)}
				status={isDisabled ? 'inactive' : 'primary'}
				text={t('options_section.strings.download_log')}
			/>
			{openModal &&
				<Modal unmount={() => {
					setDate('')
					setOpenModal(false)
					setShowError(false)
				}}
				label={t('options_section.strings.download_log')}
				width={600}
				height={400}
				>
					<div style={{ display: 'flex', marginBottom: '15px' }}>
						<Terminal />
						<p style={{ marginLeft: '5px', fontSize: '17px' }}>{deviceName}</p>
					</div>
					<DateTimePicker
						noForm
						label={t('common.fields.from_date')}
						value={date}
						onChange={setDate}
					/>
					<Divider />
					<SButtonsContainer>
						<Button
							onClick={e => handleGetLog('general')}
							status={!date ? 'inactive' : 'primary'}
							loading={loading}
							text={t('options_section.strings.general_logs')}
							fWidth
						/>
						<Button
							onClick={e => handleGetLog('user')}
							status={!date ? 'inactive' : 'primary'}
							loading={loading}
							text={t('options_section.strings.user_logs')}
							fWidth
						/>
					</SButtonsContainer>
					{showError && <h2 style={{ color: '#dd5860', fontSize: '11px', marginTop: '16px' }}>{t('options_section.strings.not_existed_log')}</h2>}
				</Modal>
			}
		</>
	)
}

const SButtonsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	button {
		flex-basis: 45%;
	}
`

export default DownloadLogs

